var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { EColumnType } from '../../../../enum/EColumnType';
import draggable from 'vuedraggable';
import CarouselItem from './assemblyItems/carousel';
import CategoryItem from './assemblyItems/category';
import RecommendItem from './assemblyItems/recommend';
import QuickLinkItem from './assemblyItems/quickLink';
import NoData from './assemblyItems/nodata';
var Preview = (function (_super) {
    __extends(Preview, _super);
    function Preview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.config = [];
        _this.deleteItem = null;
        _this.EColumnType = EColumnType;
        return _this;
    }
    Preview.prototype.initFormData = function (newVal) {
        this.initConfig(newVal);
    };
    Preview.prototype.initConfig = function (newVal) {
        this.config = newVal;
    };
    Preview.prototype.onDeleteItem = function () {
        var front_id = (this.deleteItem && this.deleteItem.front_id) || null;
        var config = JSON.parse(JSON.stringify(this.config));
        (config || []).map(function (v, index) {
            if (v.front_id == front_id) {
                config.splice(index, 1);
            }
        });
        var configLen = Array.isArray(config) ? config.length : 0;
        if (configLen === 0) {
            var noDataConfig = [
                {
                    front_id: 'no-data-id',
                    type: 'no-data',
                    typeName: 'no-data',
                    class: 'preview-target',
                },
            ];
            this.config = noDataConfig;
        }
        else {
            this.config = config;
        }
        this.$emit('delete-preview-item', this.deleteItem);
        this.$emit('drag-config', this.config);
    };
    Preview.prototype.onEnd = function () {
        this.$emit('drag-config', this.config);
    };
    Preview.prototype.onAdd = function (e) {
        var front_id = 1;
        var config = [];
        this.config.map(function (v) {
            if (v.type !== 'no-data') {
                v.front_id = front_id;
                v.class = 'preview-target';
                front_id++;
                var images = Array.isArray(v.data.images) ? v.data.images : [];
                v.data.images = images.map(function (i) {
                    var imageType = i.url && i.url.split('/')[1];
                    if (imageType === 'static' && v.typeName !== 'quick-link-item') {
                        i.url = '';
                    }
                    return i;
                });
                config.push(v);
            }
        });
        this.config = config;
        this.$emit('drag-config', this.config);
    };
    Preview.prototype.onMove = function (e, originalEvent) {
        if ((e.relatedContext.element || {}).class == 'subassembly-target') {
            return false;
        }
    };
    Preview.prototype.showConfig = function (item) {
        if (!item.current) {
            this.config = this.config.map(function (v) {
                if (v.front_id === item.front_id) {
                    v.current = true;
                }
                else {
                    v.current = false;
                }
                return v;
            });
            item.current = true;
            this.$emit('config-item', item);
        }
        this.deleteItem = item;
    };
    __decorate([
        Prop({
            type: Array
        })
    ], Preview.prototype, "formData", void 0);
    __decorate([
        Watch('formData')
    ], Preview.prototype, "initFormData", null);
    Preview = __decorate([
        Component({
            components: {
                draggable: draggable,
                'carousel-item': CarouselItem,
                'category-item': CategoryItem,
                'recommend-item': RecommendItem,
                'quick-link-item': QuickLinkItem,
                'no-data': NoData,
            }
        })
    ], Preview);
    return Preview;
}(Vue));
export default Preview;
